import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { routes } from './app.routes';
import { generalHttpInterceptor } from './interceptors/general-http.inteceptor';
import {
  MediaPlayerEffects,
  RadiosAPIEffects,
  UserEffects,
  SuggestedRadiosEffects,
} from './player.effects';
import {
  allRadiosReducer,
  mediaPlayerReducer,
  searchStateReducer,
  userCountryCodeReducer,
  suggestedRadiosReducer,
} from './player.reducer';
import { equalizerReducer } from './equalizer.reducer';
import { EqualizerEffects } from './equalizer.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([generalHttpInterceptor])),
    provideStore({
      staticMediaPlayerCurrentState: mediaPlayerReducer,
      allRadios: allRadiosReducer,
      suggestedRadios: suggestedRadiosReducer,
      searchState: searchStateReducer,
      userCountryCode: userCountryCodeReducer,
      equalizer: equalizerReducer,
    }),
    provideEffects([
      MediaPlayerEffects,
      RadiosAPIEffects,
      UserEffects,
      SuggestedRadiosEffects,
      EqualizerEffects,
    ]),
  ],
};
